export const isOfferVehicleConfigMisMatch = (offer, vinResults) => {
  const cadsUsed = isCadsUsedForOfferOrVinResults(offer, vinResults)
  const cadsFlags = cadsFlagsForVinVerifiedCheck(offer, vinResults)

  if (cadsUsed) {
    const misMatchedOptions =
      offer && offer.prospect.options && vinResults && vinResults.options
        ? vinResults.options.filter(({ optionId: id1 }) => !offer.prospect.options.some(({ optionId: id2 }) => id2 === id1)).concat(offer.prospect.options.filter(({ optionId: id1 }) => !vinResults.options.some(({ optionId: id2 }) => id2 === id1)))
        : []

    const engineMisMatch = cadsFlags.enginesVinVerified && offer && offer.prospect.vehicle && vinResults && vinResults.engines && !vinResults.engines.some(engine => engine.engineId === offer.prospect.vehicle.engineId)
    const transmissionMisMatch =
      cadsFlags.transmissionsVinVerified && offer && offer.prospect.vehicle && vinResults && vinResults.transmissions && !vinResults.transmissions.some(transmission => transmission.transmissionId === offer.prospect.vehicle.transmissionId)
    const drivetrainMisMatch = cadsFlags.drivetrainsVinVerified && offer && offer.prospect.vehicle && vinResults && vinResults.drivetrains && !vinResults.drivetrains.some(drivetrain => drivetrain.drivetrainId === offer.prospect.vehicle.drivetrainId)
    const colorMisMatch = cadsFlags.colorsVinVerified && offer && offer.prospect.vehicle && vinResults && vinResults.colors && !vinResults.colors.some(color => color.colorId === offer.prospect.vehicle.colorId)
    const optionsMismatch = cadsFlags.optionsVinVerified && offer && offer.prospect.options && misMatchedOptions.length !== 0
    const mismatchOverride = engineMisMatch || transmissionMisMatch || drivetrainMisMatch || colorMisMatch || optionsMismatch

    return mismatchOverride
  }
  // VRS prospect VRS vin results
  else {
    return false
  }
}
export const isCadsUsedForOfferOrVinResults = (offer, vinResults) => {
  const cadsFlags =
    offer && offer.prospect.vehicle.vehicleBuildDataFlags && offer.prospect.vehicle.vehicleBuildDataFlags.cadsUsed
      ? offer.prospect.vehicle.vehicleBuildDataFlags
      : vinResults && vinResults.cadsUsed
      ? {
          cadsUsed: vinResults.cadsUsed,
          transmissionsVinVerified: vinResults.transmissionsVinVerified,
          enginesVinVerified: vinResults.enginesVinVerified,
          drivetrainsVinVerified: vinResults.drivetrainsVinVerified,
          optionsVinVerified: vinResults.optionsVinVerified,
          colorsVinVerified: vinResults.colorsVinVerified
        }
      : {
          cadsUsed: false,
          transmissionsVinVerified: false,
          enginesVinVerified: false,
          drivetrainsVinVerified: false,
          optionsVinVerified: false,
          colorsVinVerified: false
        }
  return cadsFlags && cadsFlags.cadsUsed
}

export const cadsFlagsForVinVerifiedCheck = (offer, vinResults) => {
  return offer && offer.prospect.vehicle.vehicleBuildDataFlags && offer.prospect.vehicle.vehicleBuildDataFlags.cadsUsed
    ? offer.prospect.vehicle.vehicleBuildDataFlags
    : vinResults && vinResults.cadsUsed
    ? {
        cadsUsed: vinResults.cadsUsed,
        transmissionsVinVerified: vinResults.transmissionsVinVerified,
        enginesVinVerified: vinResults.enginesVinVerified,
        drivetrainsVinVerified: vinResults.drivetrainsVinVerified,
        optionsVinVerified: vinResults.optionsVinVerified,
        colorsVinVerified: vinResults.colorsVinVerified
      }
    : {
        cadsUsed: false,
        transmissionsVinVerified: false,
        enginesVinVerified: false,
        drivetrainsVinVerified: false,
        optionsVinVerified: false,
        colorsVinVerified: false
      }
}

export const cadsFlagsOfferVinDecodeMisMatch = (offer, vinResults) => {
  // check if vinResults or offer is even retrieved return false if so
  if (vinResults === undefined || offer === undefined) return false
  const offerCadsUsed = offer && offer.prospect.vehicle.vehicleBuildDataFlags && offer.prospect.vehicle.vehicleBuildDataFlags.cadsUsed
  const vinResultsCadsUsed = vinResults && vinResults.cadsUsed

  if (isEditOffer(offer)) {
    // check if we need to override the vehicle config
    // we will override if there is no match to the cads flag
    return offerCadsUsed !== vinResultsCadsUsed
  } else {
    // always override based off of resubmit
    return true
  }
}
export const isEditOffer = offer => {
  return offer && !offer.isExpired
}
export const isResubmitOffer = offer => {
  return offer && offer.isExpired
}
